import { AuthenticatedRequest, HTTPMethod, APIVersion } from "../requests/request";
import { PagingInfo } from "./media";
import { NewsFeedItem, NewsProvider } from "../models";

export class API {

    /**
     * Fetches the newsfeed
     * @returns {Promise<NewsFeedItem[]>} The Promise contains an APIError if rejected
     */
    public static getNewsFeed(search: string | undefined, paging: PagingInfo): Promise<NewsFeedItem[]> {
        let apiRequest = new AuthenticatedRequest<NewsFeedItem>('/newsfeed', HTTPMethod.GET, APIVersion.v1_2, {
            limit: paging.limit,
            skip: paging.skip,
            term: search
        });

        return apiRequest.send(NewsFeedItem).then((response) => {
            return <NewsFeedItem[]>response.data;
        });
    }

    /**
     * Fetches the newsfeed for the followed providers
     * @returns {Promise<NewsFeedItem[]>} The Promise contains an APIError if rejected
     */
    public static getFollowingNewsFeed(search: string | undefined, paging: PagingInfo): Promise<NewsFeedItem[]> {
        let apiRequest = new AuthenticatedRequest<NewsFeedItem>('/newsfeed/following', HTTPMethod.GET, APIVersion.v1_2, {
            limit: paging.limit,
            skip: paging.skip,
            term: search
        });

        return apiRequest.send(NewsFeedItem).then((response) => {
            return <NewsFeedItem[]>response.data;
        });
    }

    /**
     * Fetches the available news providers
     * @returns {Promise<NewsProvider[]>} The Promise contains an APIError if rejected
     */
    public static getNewsProviders(paging: PagingInfo): Promise<NewsProvider[]> {
        let apiRequest = new AuthenticatedRequest<NewsProvider>('/news/providers', HTTPMethod.GET, APIVersion.v1_2);

        return apiRequest.send(NewsProvider).then((response) => {
            return <NewsProvider[]>response.data;
        });
    }
    /**
     * Fetches the available news providers
     * @returns {Promise<NewsProvider[]>} The Promise contains an APIError if rejected
     */
    public static getNewsForProvider(provider_id: string, search: string | undefined, paging: PagingInfo): Promise<NewsFeedItem[]> {
        let apiRequest = new AuthenticatedRequest<NewsFeedItem>('/news/providers/' + provider_id + '/newsfeed', HTTPMethod.GET, APIVersion.v1_2, {
            limit: paging.limit,
            skip: paging.skip,
            term: search
        });

        return apiRequest.send(NewsFeedItem).then((response) => {
            return <NewsFeedItem[]>response.data;
        });
    }

    /**
    * Fetches the news
    * @returns {Promise<NewsProvider[]>} The Promise contains an APIError if rejected
    */
    public static getNewsForProviderSlug(provider_id: string, slug: string): Promise<NewsFeedItem> {
        let apiRequest = new AuthenticatedRequest<NewsFeedItem>('/news/providers/' + provider_id + '/' + encodeURIComponent(slug), HTTPMethod.GET, APIVersion.v1_2);
        return apiRequest.send(NewsFeedItem).then((response) => {
            return <NewsFeedItem>response.data;
        });
    }

    /**
     * Follows the provider with the given id
     * @returns {Promise<NewsProvider>} The Promise contains an APIError if rejected
     */
    public static followProvider(provider_id: string): Promise<NewsProvider> {
        let apiRequest = new AuthenticatedRequest<NewsProvider>('/news/providers/' + provider_id + '/follow', HTTPMethod.POST, APIVersion.v1_2);

        return apiRequest.send(NewsProvider).then((response) => {
            return <NewsProvider>response.data;
        });
    }

    /**
     * Follows the provider with the given id
     * @returns {Promise<NewsProvider>} The Promise contains an APIError if rejected
     */
    public static unfollowProvider(provider_id: string): Promise<NewsProvider> {
        let apiRequest = new AuthenticatedRequest<NewsProvider>('/news/providers/' + provider_id + '/unfollow', HTTPMethod.POST, APIVersion.v1_2);

        return apiRequest.send(NewsProvider).then((response) => {
            return <NewsProvider>response.data;
        });
    }

}



// WEBPACK FOOTER //
// ./src/api/src/endpoints/news.ts